import { ParentState } from "@hopper-b2b/checkout";
import {
  PreAuthorizeCode,
  buildNupayState,
  checkAuthStatus,
  encodeNupayState,
} from "../api/checkAuthStatus";

export const checkAuthStatusService = (context, _event: unknown) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const nupayDirect =
        context?.[ParentState.featureFlags]?.enableNupayDirect ?? false;
      const response = await checkAuthStatus({ nupayDirect });
      const hasAuth = response.value.code === PreAuthorizeCode.ALREADY_APPROVED;

      // For already-approved users, we need the encoded state so the BFF can
      // determine which payment provider (Ebanx vs NuPay) to use when listing
      // payment methods. For new enrollments, nupayOAuthState is set later
      // via setAuthorizationCode when the OAuth callback returns.
      const nupayOAuthState =
        nupayDirect && hasAuth
          ? encodeNupayState(buildNupayState())
          : undefined;

      resolve({
        hasAuth,
        redirectUrl: response.value.redirectUrl,
        nupayOAuthState,
        paymentType: response.value.payment,
      });
    } catch (error) {
      reject({
        error,
      });
    }
  });
